import { render, staticRenderFns } from "./homePlaceholder.vue?vue&type=template&id=cd881510&scoped=true"
import script from "./homePlaceholder.vue?vue&type=script&lang=js"
export * from "./homePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./homePlaceholder.vue?vue&type=style&index=0&id=cd881510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd881510",
  null
  
)

export default component.exports